import { createFileRoute, Link } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Users } from "lucide-react";

export const Route = createFileRoute("/admin/drivers")({
  component: () => (
    <StubAdminPage
      icon={Users}
      title="Drivers"
      subtitle="Manage drivers and assignments"
      action={
        <Link
          to="/admin"
          hash="drivers"
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Add driver
        </Link>
      }
    />
  ),
});
